export default "__VITE_ASSET__C0M9UEvG__"